import { createSelector } from 'reselect';

import { StoreState } from '../../reducers';
import Utils from '../../utils';
import { Api } from '../../typings/api';

const getApplicationUrl = (state: StoreState): string => state.galleryInfos.config.applicationUrl;

const getNewAvatar = createSelector(
	(state: StoreState): File | null | undefined => state.profile.userAvatar.file,
	(file: File): string => file ? URL.createObjectURL(file) : '',
);

const getCurrentAvatar = createSelector(
	(state: StoreState): string | null => state.profile.photoPath,
	getApplicationUrl,
	(photoPath: string, applicationUrl: string): string => photoPath ? Utils.getUrlForSecuredResource(`${applicationUrl}/${photoPath}`) : '',
);

export const getAvatarUrl = createSelector(
	getNewAvatar,
	getCurrentAvatar,
	(newAvatar: string, currentAvatar: string): string => newAvatar || currentAvatar,
);

const getCustomerRole = (state: StoreState): Api.CustomerContextRoles => state.profile.role;

const getIsAccountManager = createSelector(
	getCustomerRole,
	(role: Api.CustomerContextRoles): boolean => (
		[
			Api.CustomerContextRoles.ROLE_SAAS_ACCOUNT_MANAGER,
			Api.CustomerContextRoles.ROLE_CONSUMER,
		].includes(role)
	),
);

const getIsAdmin = createSelector(
	getCustomerRole,
	(role: Api.CustomerContextRoles): boolean => (
		[
			Api.CustomerContextRoles.ROLE_ALL_RIGHTS,
			Api.CustomerContextRoles.ROLE_PRODUCTION,
		].includes(role)
	),
);

export const getIsAccountManagerOrAdmin = createSelector(
	getIsAccountManager,
	getIsAdmin,
	(isAccountManager: boolean, isAdmin: boolean): boolean => isAccountManager || isAdmin,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/selectors.tsx